import React from 'react';
import {Box} from '../Box/Box';

import type {BoxProps} from '../Box/Box';

export type FooterContainerProps = Pick<BoxProps, 'sx' | 'component' | 'children'>;

export const FooterContainer = React.forwardRef<any, FooterContainerProps>(({
    children, sx, ...props
}, ref): React.ReactElement => (
    <Box
        ref={ref}
        sx={{
            display: 'flex',
            flexDirection: 'row',
            margin: '0 auto',
            maxWidth: '1280px',
            padding: '1.25rem',
            ...sx
        }}
        {...props}
    >
        {children}
    </Box>
));

FooterContainer.displayName = 'FooterContainer';
